import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb, BreadcrumbItem, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { Home } from "react-feather";
import Select from "react-select";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import { KIBANA_PLM_URL, KIBANA_PLM_INTERNAL_URL } from "../../Common/KibanaAPIEndpoints/KibanaAPIEndpoints";

import { useKibanaAuthentication } from "../../hooks/useKibanaAuthentication";

export default function AvgAvailableWorkersInResqueJobs() {

  const {setToken} = useKibanaAuthentication();

  const [loading, setLoading] = useState(true)

  const search = useLocation().search;
  const commit = new URLSearchParams(search).get("commit");
  const searchParams = {
    clusterName: new URLSearchParams(search).get("filter[cluster_name]"),
    passType: new URLSearchParams(search).get("filter[pass_type]"),
    jobType: new URLSearchParams(search).get("filter[job_type]"),
    fromTime: new URLSearchParams(search).get("filter[time]")
  }
  const [clusterName, setClusterName] = useState({ label: 'All', value: '*' });
  const [passType, setPassType] = useState({label: 'All', value: '*'});
  const [jobType, setJobType] = useState({label: 'All', value: '*'});
  const [fromTime, setFromTime] = useState({ label: 'Last 24 hours', value: 'now-24h' });

  const jobTypeOptions = [
    { label: 'All', value: '*' },
    { label: 'Recrawl', value: 'recrawl' },
    { label: 'Distributed Recrawl', value: 'distributed_recrawl' },
    { label: 'Feedcrawl', value: 'feedcrawl3' },
    { label: 'Dependent Data Upload', value: 'dependent_data_upload' },
    { label: 'Total Workers', value: 'total_workers' },
  ]

  const clusterNameOptions = [
    { label: 'All', value: '*' },
    { label: 'cluster1', value: 'cluster1' },
    { label: 'cluster2', value: 'cluster2' },
  ]

  const passTypeOptions = [
    { label: 'All', value: '*' },
    { label: 'pass1', value: 'pass1' },
    { label: 'pass2', value: 'pass2' },
  ]

  const timeOptions = [
    { label: 'Today', value: 'now%2Fd' },
    { label: 'Last 30 minutes', value: 'now-30m' },
    { label: 'Last 1 hour', value: 'now-1h' },
    { label: 'Last 2 hours', value: 'now-2h' },
    { label: 'Last 4 hours', value: 'now-4h' },
    { label: "Last 10 hours", value: "now-10h" },
    { label: 'Last 12 hours', value: 'now-12h' },
    { label: 'Last 24 hours', value: 'now-24h' },
    { label: 'Last 2 days', value: 'now-2d' },
    { label: 'Last 3 days', value: 'now-3d' },
    { label: 'Last 4 days', value: 'now-4d' },
    { label: 'Last 7 days', value: 'now-7d' },
    { label: 'Last 15 days', value: 'now-15d' },
    { label: 'Last 30 days', value: 'now-30d' },
    { label: 'Last 60 days', value: 'now-60d' },
    { label: 'Last 1 year', value: 'now-1y' }
  ];

  const [UrlParams, setUrlParams] = useState({
    passType: "*",
    jobType: '*',
    clusterName: '*',
    fromTime: 'now-24h'
  })

  useEffect(() => {
    setSearchParamsData();
    async function fetchInitialData() {
      try {
        setLoading(true);
        await setToken(KIBANA_PLM_URL)
      } catch (err) {
        console.error("Failed to fetch data", err);
      } finally {
        setLoading(false);
      }
    }

    fetchInitialData();
  }, []);

  const capitalize = (str, lower = false) => (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());

  function setSearchParamsData() {
    console.log("searchParams", searchParams);
    if (searchParams.jobType && searchParams.jobType != jobType.value) {
      setJobType({ label: searchParams.jobType  == '*' ? 'All' : capitalize((searchParams.jobType)?.replaceAll('_', ' ')), value: searchParams.jobType });
    }
    if (searchParams.clusterName && searchParams.clusterName != clusterName.value) {
      setClusterName({ 
        label: searchParams.clusterName  == '*' ? 'All' :  searchParams.clusterName, 
        value: searchParams.clusterName  == 'All' ? '*' :  searchParams.clusterName 
      });
    }
    if (searchParams.passType && searchParams.passType != passType.value) {
      setPassType({ 
        label: searchParams.passType  == '*' ? 'All' :  searchParams.passType, 
        value: searchParams.passType  == 'All' ? '*' :  searchParams.passType 
      });
    }
    if (searchParams.fromTime && searchParams.fromTime != fromTime.value) {
      setFromTime(timeOptions.filter(item => item.value == searchParams.fromTime)[0]);
    }
    if (commit == 'Get Data' && searchParams.fromTime && searchParams.passType && searchParams.jobType && searchParams.clusterName) {
      setUrlParams(searchParams)
    }
  }

  function avgAvailableWorkersInResqueJobsKibanaUrl(kibana_url){
    var to_time_val = UrlParams.fromTime == "now%2Fd" ? "now%2Fd" : "now";
    var cluster_name_val = UrlParams.clusterName == "All" ? "*" : UrlParams.clusterName;
    var pass_type_val = UrlParams.passType == "All" ? "*" : UrlParams.passType;

    return `${kibana_url}app/kibana#/visualize/create?type=line&indexPattern=8c44ed90-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(pause:!t,value:0),time:(from:'${UrlParams.fromTime}',to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:'custom:+%22enqueue_resque_jobs_available_workers_tracker%22+AND+cluster:${cluster_name_val}+AND+pass_type:${pass_type_val}+AND+job_type:${UrlParams.jobType}'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(field:total_jobs_need_to_push),schema:metric,type:avg),(enabled:!t,id:'2',params:(drop_partials:!f,extended_bounds:(),field:'@timestamp',interval:auto,min_doc_count:1,scaleMetricValues:!f,timeRange:(from:now-24h,to:now),useNormalizedEsInterval:!t),schema:segment,type:date_histogram),(enabled:!t,id:'3',params:(field:available_workers),schema:metric,type:avg)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),dimensions:(x:(accessor:0,aggType:date_histogram,format:(id:date,params:(pattern:'HH:mm')),params:(bounds:(max:'2021-10-06T09:22:28.154Z',min:'2021-10-05T09:22:28.154Z'),date:!t,format:'HH:mm',interval:PT30M,intervalESUnit:m,intervalESValue:30)),y:!((accessor:1,aggType:avg,format:(id:number),params:()))),grid:(categoryLines:!f),labels:(),legendPosition:right,seriesParams:!((data:(id:'1',label:'Average+total_jobs_need_to_push'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1),(data:(id:'3',label:'Average+available_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1)),thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:line,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(mode:normal,type:linear),show:!t,style:(),title:(text:'Average+total_jobs_need_to_push'),type:value))),title:'',type:line))`
  }

  const handleGetData = () => {
    window.location.href = `/internal/resque_info/avg_available_workers_in_resque_jobs?filter[pass_type]=${passType.value}&filter[job_type]=${jobType.value}&filter[cluster_name]=${clusterName.value}&filter[time]=${fromTime.value}&commit=${'Get Data'}`
  }

  if(loading) {
    return (
      <Loader type="Puff" color="#00BFFF" height={100} width={100} className='pc-loader' />
    )
  }

  return <Container fluid>
    <div className="page-title">
      <Row className=''>
        <Col xs="6">
          <h3>Internal Dashboard</h3>
        </Col>
        <Col xs="6">
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to={'/internal'}>
                <Home />
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              {commit == 'Get Data' ? <a href="/internal/resque_info/avg_available_workers_in_resque_jobs">Avg available workers in resque jobs</a> : 'Avg available workers in resque jobs'}
            </BreadcrumbItem>
            {commit == 'Get Data' && <BreadcrumbItem className="fw-bold">
                Search
                </BreadcrumbItem>}
          </Breadcrumb>
        </Col>
      </Row>
    </div>

    <Card>
      <CardBody>
        <Row>
          <Col sm="4">
            <label className="fw-bold">Choose Cluster</label>
            <Select
              value={clusterName}
              options={clusterNameOptions}
              onChange={option => setClusterName(option)} />
          </Col>
          <Col sm="4">
            <label className="fw-bold">Pass Type</label>
            <Select
              value={passType}
              options={passTypeOptions}
              onChange={option => setPassType(option)} />
          </Col>
          <Col sm="4">
            <label className="fw-bold">Job Type</label>
            <Select
              value={jobType}
              options={jobTypeOptions}
              onChange={option => setJobType(option)} />
          </Col>
        </Row>
        <Row className="align-items-end mt-4">
          <Col sm="4">
            <label className="fw-bold">Time</label>
            <Select
              value={fromTime}
              options={timeOptions}
              onChange={option => setFromTime(option)} />
          </Col>
          <Col sm="4">
            <button className="btn btn-success w-100" onClick={handleGetData}>Get Data</button>
          </Col>
        </Row>
      </CardBody>
    </Card>
    <Card>
      <CardBody>
        <center>
          <span className="fw-bold">Avg available workers in resque jobs</span><br />
          <a target="_blank" className="link-primary" href={avgAvailableWorkersInResqueJobsKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
        </center>
        <iframe src={avgAvailableWorkersInResqueJobsKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="500" width="100%" className="border-0"></iframe>
      </CardBody>
    </Card>
  </Container>
}

